export default "__VITE_ASSET__d0621004__"